// Copyright 2018-2025 the Deno authors. MIT license.
import { DEFAULT_CONFIG } from "./_config.js";
export const state = {
  handlers: new Map(),
  loggers: new Map(),
  config: DEFAULT_CONFIG
};
//# sourceMappingURL=_state.js.map